/**
 * @fuegokit/tokens 0.10.7
 * Do not edit directly
 * Generated on Wed, 20 Sep 2023 00:32:17 GMT
 */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
  radii: {
    "0": "0px",
    "1": "3px",
    "2": "4px",
    "3": "6px",
    "4": "8px",
    "5": "9999999px",
  },
};
